import React from 'react'
import PropTypes from 'prop-types'
import parse from 'html-react-parser';
import { Svg } from '../../1_Atoms/Svg/Svg'
import Button from '../../1_Atoms/Button/Button'

function FormConfirmation({
  heading,
  subHeading,
  firstName,
  isDark,
  onClick,
  buttonLabel,
}) {

const parseSub = firstName? subHeading.replace('|firstName|', firstName) : subHeading;

  return (
    <div className={`mz-form-confirmation ${isDark ? 'mz-form-confirmation--dark' : ''}`}>
      <Svg
        type="checkmark"
        size={3}
        colour={isDark ? 'white' : 'black'}
      />
      <h3>{heading}</h3>
      <div className="paragraph">{parse(parseSub)}</div>
     {buttonLabel? <Button
        type="submit"
        className={`mz-btn--secondary ${isDark ? 'mz-btn--black' : ''}`}
        label={buttonLabel}
        onClick={onClick}
      /> : ''}
    </div>
  )
}

FormConfirmation.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string,
  firstName: PropTypes.string,
  isDark: PropTypes.bool,
  onClick: PropTypes.func,
  buttonLabel: PropTypes.string,
}

FormConfirmation.defaultProps = {
  isDark: false,
}

export default FormConfirmation